import React from "react";
import { cn } from "../../../lib/utils";

const VARIANTS = {
  /** Outlined — tags, unset filter chips. */
  outline: "border border-eh-border-soft text-eh-ink bg-white",
  /** Filled — a filter that has a value, "New". */
  filled: "border border-transparent bg-eh-cream-deep text-eh-ink",
  /** Selected segment / active filter chip. */
  selected: "border border-transparent bg-eh-ink text-eh-bg",
  /** Neutral token (merge fields, "required"). */
  neutral: "border border-eh-border-soft bg-eh-cream text-eh-ink",
};

/** A small pill. Long labels truncate (FR/ES copy runs longer) and keep the full text in `title`. */
export default function Chip({ variant = "outline", as: Tag = "span", className, title, children, ...rest }) {
  return (
    <Tag title={title}
      className={cn("inline-flex max-w-[16rem] items-center gap-1 truncate rounded-full px-2.5 py-0.5 text-xs", VARIANTS[variant], className)}
      {...rest}>
      {children}
    </Tag>
  );
}
